import { render } from "./slidestc_00overview_en.vue?vue&type=template&id=5a483490&scoped=true"
import script from "./slidestc_00overview_en.vue?vue&type=script&lang=js"
export * from "./slidestc_00overview_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=5a483490&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a483490"]])

export default __exports__